import { useGetAllTabsUserHasAccessToQuery } from "../../redux/api/user";
import { useEffect, useState } from "react";
import { Tabs } from "antd";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import ProductGroupingPage from "../../containers/Settings/ProductGroupingPage";
import SettingsDropdowns from "../../containers/PaidMedia.js/SettingsDropdowns";
import ExtraCostSettingsPage from "../../containers/Settings/ExtraCostSettingsPage";
import BudgetTrackerSettingsPage from "../../containers/Settings/BudgetTrackerSettingsPage";
import BoxMetricSettings from "../../components/Settings/BoxMetricsSettings";
import PageContentSettingsPage from "../../containers/Settings/PageContentSettingsPage";
import CompassMultiplierConfigPage from "../../containers/Settings/CompassMultiplierConfigPage";
import { Layout } from "antd";

export default function SettingsPage() {
  const [tabs, setTabs] = useState([]);

  const allowedTabs = useGetAllTabsUserHasAccessToQuery();

  useEffect(() => {
    if (allowedTabs.isSuccess) {
      var tmpTabs = [];
      tmpTabs.push({
        label: "Box Metrics",
        key: "Box Metrics",
        children: [<BoxMetricSettings />],
      });
      tmpTabs.push({
        label: "Page Content",
        key: "Page Content",
        children: [<PageContentSettingsPage />],
      });
      for (var i = 0; i <= allowedTabs.data.length; i++) {
        const tab = allowedTabs.data[i];
        if (tab == "executive_summary") {
          tmpTabs.push({
            label: "Product Grouping (Shopify)",
            key: "Product Grouping",
            children: [<ProductGroupingPage />],
          });
        } else if (tab == "amazon") {
          tmpTabs.push({
            label: "Product Grouping (Amazon)",
            key: "Product Grouping (Amazon)",
            children: [<ProductGroupingPage platform={"Amazon"} />],
          });
        } else if (tab == "paid_media") {
          tmpTabs.push({
            label: "Google Settings",
            key: "Google Settings",
            children: [<SettingsDropdowns platform="google" />],
          });
          tmpTabs.push({
            label: "Facebook Settings",
            key: "Facebook Settings",
            children: [<SettingsDropdowns platform="facebook" />],
          });
          tmpTabs.push({
            label: "Tiktok Settings",
            key: "Tiktok Settings",
            children: [<SettingsDropdowns platform="tiktok" />],
          });
          tmpTabs.push({
            label: "Bing Settings",
            key: "Bing Settings",
            children: [<SettingsDropdowns platform="bing" />],
          });
          tmpTabs.push({
            label: "Pinterest Settings",
            key: "Pinterest Settings",
            children: [<SettingsDropdowns platform="pinterest" />],
          });
          tmpTabs.push({
            label: "Reddit Settings",
            key: "Reddit Settings",
            children: [<SettingsDropdowns platform="reddit" />],
          });
        }
      else if (tab == "budget_planner") {
          tmpTabs.push({
          label: "Target Settings",
          key: "Target Settings",
            children: [<BudgetTrackerSettingsPage />],
          });
        }
        else if (tab == "compass_multipliers_config") {
          tmpTabs.push({
            label: "Compass Multipliers Config",
            key: "Compass Multipliers Config",
            children: [<CompassMultiplierConfigPage />],
          });
        }

        if (!tmpTabs.some((tab) => tab.label === "Extra Costs")) {
          tmpTabs.push({
            label: "Extra Costs",
            key: "Extra Costs",
            children: [<ExtraCostSettingsPage />],
          });
        }
      }
      setTabs(tmpTabs);
    }
  }, [allowedTabs]);

  return (
    <Layout.Content
      style={{
        display: "flex",
        flexDirection: "column",
        // width: "100%",
        // padding: "0 24px",
      }}
    // className="main-content-container"
    >
      <GenericReportingDropdowns includeSingleSelectRegion={true} />
      <Tabs
        style={{
          //   width: "95vw",
          width: "100%",
          //   overflow: "auto",
        }}
        items={tabs}
      />
    </Layout.Content>
  );
}